const ClockIcon = ({ ..._props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C10.22 3 8.47991 3.52784 6.99987 4.51677C5.51983 5.50571 4.36628 6.91131 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89471 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4441 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C20.9973 9.61389 20.0482 7.3263 18.3609 5.63906C16.6737 3.95183 14.3861 3.00274 12 3ZM15.1974 14.605L11.5974 12.805C11.4479 12.7303 11.3222 12.6154 11.2344 12.4732C11.1465 12.331 11.1 12.1671 11.1 12V7.5C11.1 7.2613 11.1948 7.03239 11.3636 6.8636C11.5324 6.69482 11.7613 6.6 12 6.6C12.2387 6.6 12.4676 6.69482 12.6364 6.8636C12.8052 7.03239 12.9 7.2613 12.9 7.5V11.4436L16.0026 12.9949C16.2161 13.1016 16.3785 13.2888 16.4539 13.5153C16.5294 13.7418 16.5119 13.989 16.4051 14.2025C16.2983 14.416 16.1111 14.5784 15.8846 14.6539C15.6581 14.7294 15.411 14.7118 15.1974 14.605Z"
        fill="#FB3973"
      />
    </svg>
  );
};

export default ClockIcon;
